const CountryList = ({ countryFlag, country }) => {
    return (
        <div className="flex items-center phone:space-x-2 space-x-4">
            <div className="w-fit tablet:w-[47px] tablet:h-[40px] phone:p-[7px] p-[8px] rounded-lg bg-[#F9F9FB]">
                <img src={`/images/homepage/flags/${countryFlag}.svg`} className="w-[40px] h-[30px] phone:w-[34px] phone:h-[25px] tablet:w-[34px] tablet:h-[25px]" width="40px" height="30px" alt={countryFlag} />
            </div>
            <div>
                <h3 className="font-semibold tracking-text text-primary-dark text-[16px] phone:text-[14px] tablet:text-[14px] phone:leading-[17.35px]">{country}</h3>
                <p className="tablet:text-xs text-sm -mt-[2px] phone:text-xs font-normal text-neutral-50 tracking-text">Proxy</p>
            </div>
        </div>
    );
};

export default CountryList;